// extracted by mini-css-extract-plugin
module.exports = {"match-buttons":"MatchPriceButtons_match-buttons__PBpkn","match":"MatchPriceButtons_match__O8uTG"};